import { Injectable } from "@angular/core";
import { IProfileActionService } from "../IProfileActionService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Observable } from "rxjs";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class ProfilePromiseActionService implements IProfileActionService {
  constructor() {}

  abstract updateProfile(
    profileSettings: Array<CubiqTS.ProfileSettingImpl>,
    isUserSettings: boolean,
  ): Promise<void>;

  abstract getProfileConfig(profileSettingKey: string): Promise<string>;

  abstract getProfileConfigUpdates(profileSettingKey: string): Observable<string>;

  abstract getProfileSettings(): Promise<any>;

  abstract createUserSettingsProfileUpdateRequest(): Promise<CubiqTS.ProfileUpdateRequestImpl>;

  abstract isPrimed(): Promise<boolean>;
}
